<template>
  <div>
    Stochastic %K over {{ rule.config.days }} days is {{ rule.config.above_below }}
    {{ rule.config.threshold }}
  </div>
</template>

<script>
export default {
  props: {
    rule: { type: Object, required: true }
  }
}
</script>
